module.exports = __webpack_public_path__ + "static/trig_009-c716eaeda3e0b08294304f98e7072a3a.webp";